import * as React from "react";
import {useCallback, useState} from "react";
import {useStorageItemValue} from "@variocube/cube-ui";
import {HomeView} from "./home";
import {PinPadView} from "./pinpad";
import {Case, Cases, ConfigKeyCases} from "./types";
import {PickupFlow} from "./pickup-flow";
import {StorageFlow} from "./storage-flow";

export function App() {
    const [showPinPad, setShowPinPad] = useState<boolean>(false);
    const [storageCase, setStorageCase] = useState<Case | undefined>(undefined);
    const [pickupCase, setPickupCase] = useState<Case | undefined>(undefined);

    const cases = useStorageItemValue<Cases>(ConfigKeyCases);

    const handleStart = useCallback(() => {
        setShowPinPad(true);
        setStorageCase(undefined);
        setPickupCase(undefined);
    }, []);

    const handleCode = useCallback(async (code: string) => {
        if (cases && cases[code]) {
            const selectedCase = cases[code];
            setShowPinPad(false);
            if (selectedCase.occupiedFrom && selectedCase.reservationUuid) {
                setPickupCase(selectedCase);
            }
            else {
                setStorageCase(selectedCase);
            }
            return;
        }
        throw new Error(`No case found for code ${code}`);
    }, [cases]);

    if (showPinPad) {
        return (<PinPadView onCode={handleCode} onCancel={() => setShowPinPad(false)}/>);
    }

    if (pickupCase) {
        return (<PickupFlow pickupCase={pickupCase} onDone={() => setPickupCase(undefined)}/>);
    }

    if (storageCase) {
        return (<StorageFlow storageCase={storageCase} onDone={() => setStorageCase(undefined)}/>);
    }

    return (<HomeView onStart={handleStart}/>);
}
